import { gql } from '@apollo/client';

export const GET_ALL_MEDIA_APPROVALS_LIST = gql`
  query getAllMediaApprovalsList(
    $maStatus: [MediaApprovalMaStatusEnum!]
    $maType: [MediaApprovalMaTypeEnum!]
    $offset: Int
    $toDate: Datetime
    $maCategoryOrGenre: [String!]
    $fromDate: Datetime
    $first: Int
    $orderBy: [MediaOrderByInput!] = { field: maUpdatedAt, direction: DESC }
  ) {
    getAllMediaApprovalsList(
      first: $first
      fromDate: $fromDate
      maCategoryOrGenre: $maCategoryOrGenre
      maStatus: $maStatus
      maType: $maType
      offset: $offset
      toDate: $toDate
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        userByMaUploadedBy {
          uFullName
          uId
        }
        maId
        maS3MediaKeyUrl
        maS3ThumbnailKeyUrl
        maStatus
        maTags
        maTitle
        maType
        maUploadedAt
        maDuration
        maCreatedAt
        maDescription
        maCategory
      }
    }
  }
`;

export type MediaApprovalMaStatus = 'PENDING' | 'APPROVED' | 'REJECTED';
export type MediaApprovalMaType = 'REELS' | 'VIDEOS';
export type MaAdditionalImage = {
  maAdditionalImagesLabelId: string;
  maAdditionalImagesS3KeyUrl: string;
  maAdditionalImagesLabelName: string;
  maAdditionalImagesLabelValue: string;
  maIsThumbnail: boolean;
};

export type GetAllMediaApprovalsListData = {
  getAllMediaApprovalsList: {
    totalCount: number;
    nodes: {
      userByMaUploadedBy: {
        uFullName: string;
        uId: string;
      };
      maId: string;
      maS3MediaKeyUrl: string;
      maS3ThumbnailKeyUrl: string;
      maStatus: MediaApprovalMaStatus;
      maTags: string[];
      maTitle: string;
      maType: MediaApprovalMaType;
      maUploadedAt: string;
      maDuration: string;
      maCreatedAt: string;
      maDescription: string;
      maCategory: string;
    }[];
  };
};

export type GetAllMediaApprovalsListVariables = {
  first?: number;
  offset?: number;
  maType?: string[];
  maStatus?: MediaApprovalMaStatus[];
  maCategoryOrGenre?: string[];
  fromDate?: string;
  toDate?: string;
  orderBy?: { field: string; direction: 'ASC' | 'DESC' }[];
};


/*
** GET MEDIA APPROVAL BY ID **
*/

export const GET_MEDIA_APPROVAL_BY_ID = gql`
  query mediaApprovalByMaId($maId: UUID!) {
    mediaApprovalByMaId(maId: $maId) {
      maId
      maDescription
      maCategory
      maTags
      maTitle
      maType
      maStatus
      maRejectionReason
      maDuration
      maS3MediaKeyUrl
      maS3ThumbnailKeyUrl
      maJwMediaId
      maAdditionalImages
      userByMaUploadedBy {
        uId
        uFullName
      }
      maCreatedAt
      genreDropdownsByMaId {
        nodes {
          dropdownByDdId {
            ddId
            ddLabel
            ddType
          }
        }
      }
      dropdownByAgeRatingId {
        ddId
        ddLabel
        ddType
      }
    }
  }
`;

export type GetMediaApprovalByIdData = {
  mediaApprovalByMaId: {
    maId: string;
    maDescription: string;
    maCategory: string;
    maTags: string | string[];
    maTitle: string;
    maType: MediaApprovalMaType;
    maStatus: MediaApprovalMaStatus;
    maRejectionReason?: string;
    maS3MediaKeyUrl: string;
    maDuration: string;
    maS3ThumbnailKeyUrl: string;
    maJwMediaId?: string;
    maAdditionalImages: MaAdditionalImage[];
    userByMaUploadedBy: {
      uId: string;
      uFullName: string;
    };
    maCreatedAt: string;
    genreDropdownsByMaId: {
      nodes: {
        dropdownByDdId: {
          ddId: string;
          ddLabel: string;
          ddType: string;
        };
      }[];
    };
    dropdownByAgeRatingId: {
      ddId: string;
      ddLabel: string;
      ddType: string;
    } | null;
  };
};

export type GetMediaApprovalByIdVariables = {
  maId: string;
};

export type GetMediaCategoryAndGenreData = {
  getMediaCategoryAndGenre: {
    totalCount: number;
    nodes: {
      ddLabel: string;
      ddValue: string;
    }[];
  };
};

export type GetMediaCategoryAndGenreVariables = {
  first: number;
  offset: number;
};

export const GET_MEDIA_CATEGORY_AND_GENRE = gql`
  query getMediaCategoryAndGenre($first: Int!, $offset: Int!) {
    getMediaCategoryAndGenre(offset: $offset, first: $first) {
      nodes {
        ddLabel
        ddValue
      }
      totalCount
    }
  }
`;

